import { render, staticRenderFns } from "./IcTopdown.vue?vue&type=template&id=962e537c&scoped=true"
import script from "./IcTopdown.vue?vue&type=script&lang=js"
export * from "./IcTopdown.vue?vue&type=script&lang=js"
import style0 from "./IcTopdown.vue?vue&type=style&index=0&id=962e537c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962e537c",
  null
  
)

export default component.exports